var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMktgPauseShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 67"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC6D2",
    d: "M35.24 66.49A28.28 28.28 0 017 38.24 28.28 28.28 0 0135.24 10 28.28 28.28 0 0163.5 38.24 28.28 28.28 0 0135.24 66.5v-.01z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M31 0c17.1 0 31 13.9 31 31S48.1 62 31 62 0 48.1 0 31 13.9 0 31 0zm0 59.24A28.28 28.28 0 0059.24 31 28.28 28.28 0 0031 2.76 28.28 28.28 0 002.76 31 28.28 28.28 0 0031 59.24zm-3.65-14.48h-7.78l-.1-26.67h7.77l.11 26.67zm15.46 0h-7.78V18.1h7.78v26.67-.01z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-mktg--pause-shadow-dc3146d1c05270cb16cbcb0c8538ee5b.svg";
export { SvgIconMktgPauseShadow as Component };